<script lang="ts" setup>
//
</script>

<template>
  <div class="tr-head">
    <slot />
  </div>
</template>
